import { environment } from "environment";

export class GlobalConstants {
  // public static apiURL: string = 'http://10.20.34.17/json/'; // test server
  // public static socketURL: string = '10.20.34.17';
  // public static staticFilesURL: string = 'http://10.20.34.17/json';
  // public static siteUrl: string = 'http://10.20.34.17/';

  // public static apiURL: string = "http://localhost:4000/json/api/v1/"; // local
  // public static socketURL: string = "http://localhost:4000";
  // public static staticFilesURL: string = "http://localhost:4000/json";

  // public static apiURL: string = 'http://localhost:3000/'; // local
  // public static socketURL: string = "http://localhost:3000";
  // public static staticFilesURL: string = "http://localhost:3000";

  public static apiURL: string = 'https://kgateapi.intwish.com/'; // test server intwish
  public static socketURL: string = "https://kgateapi.intwish.com/";
  public static staticFilesURL: string = "https://kgateapi.intwish.com";
  public static siteUrl: string = 'https://knowledgegate.intwish.com/';
 
  // public static apiURL: string = 'http://45.33.122.49:9000/'; // prod server intwish
  // public static socketURL: string = "http://45.33.122.49:9000/";
  // public static staticFilesURL: string = "http://45.33.122.49:9000";
  // public static siteUrl: string = 'https://localhost:4200/';

  // public static apiURL: string = "http://10.20.32.17/"; // prob ip
  // public static socketURL: string = "http://10.20.32.17";
  // public static staticFilesURL: string = "http://10.20.32.17";
  // public static siteUrl: string = 'http://localhost:4200/';

  // public static apiURL: string = "https://stgkgate.scbc.gov.sa/json/";
  // public static socketURL: string = "https://stgkgate.scbc.gov.sa/";
  // public static staticFilesURL: string = "https://stgkgate.scbc.gov.sa/json";
  // public static siteUrl: string = 'https://stgkgate.scbc.gov.sa/';

  // public static apiURL: string = "https://kgate.bc.gov.sa/json/";
  // public static socketURL: string = "https://kgate.bc.gov.sa/";
  // public static staticFilesURL: string = "https://kgate.bc.gov.sa/json";
  // public static siteUrl: string = 'https://kgate.bc.gov.sa/';

  public static siteTitle: string = 'Knowledge Gate Solution';
}

if (environment.production) {
  GlobalConstants.apiURL = "https://kgate.bc.gov.sa/json/";
  GlobalConstants.socketURL = "https://kgate.bc.gov.sa/";
  GlobalConstants.staticFilesURL = "https://kgate.bc.gov.sa/json";
  GlobalConstants.siteUrl = 'https://kgate.bc.gov.sa/';
}


export class ImageTypes {
  public static ou: string = 'ORGANIZATIONAL_UNIT';
  public static profile: string = 'PROFILE';
  public static assessment: string = 'ASSESSMENT';
  public static survey: string = 'SURVEY';
  public static question: string = 'QUESTION';
  public static training_material: string = 'TRAINING_MATERIAL';
  public static training_videos: string = 'TRAINING_VEDIOS';
}
